module.exports = __webpack_public_path__ + "static/media/a3.5f183d9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suchunyuan/a3.mp3
// module id = VCs7
// module chunks = 0